<template>
    <div>
        <div style=" background: #f3f3f3">
            <CellGroup title="设备信息">
                <Cell value-class="cell-value" title="设备名称" :value="data.deviceName"/>
                <Cell value-class="cell-value" title="设备类型" :value="data.productName"/>
                <Cell value-class="cell-value" title="设备编号" :value="data.deviceSn"/>
                <Cell value-class="cell-value" title="所属单位" :value="data.unitName"/>
                <Cell value-class="cell-value" title="安装位置" :value="data.installLocation"/>
            </CellGroup>
            <CellGroup title="推送信息">
                <Cell value-class="cell-value" title="消息类型" :value="bizTypeDICT"/>
                <Cell value-class="cell-value" title="接收用户" :value="message.userRealName"/>
                <Cell value-class="cell-value" title="简要内容" :value="message.content"/>
                <Cell value-class="cell-value" title="创建时间" :value="message.createdTime"/>
                <Cell value-class="cell-value" title="已读状态" :value="stateDICT"/>
                <Cell value-class="cell-value" title="已读方式" :value="readTypeDICT"/>
                <Cell value-class="cell-value" title="已读时间" :value="message.readTime"/>
                <Cell value-class="cell-value" title="推送方式" :value="resultValue"/>
                <div style="height:50px;">&nbsp;</div>
            </CellGroup>
        </div>
    </div>
</template>

<script>
    import {Button, Cell, CellGroup, Checkbox, CheckboxGroup} from 'vant';
    import * as DICT from "@/utils/dict"

    export default {
        components: {
            Button, CellGroup, Cell, CheckboxGroup, Checkbox
        },
        props: {},
        data() {
            return {
                id: this.$route.params.id,
                message: {},
                data: {}
            }
        },
        computed: {
            bizTypeDICT() {
                return DICT.getValue('PUSH_MESSAGE_BIZ_TYPE', this.message.bizType)
            },
            stateDICT() {
                return DICT.getValue('PUSH_MESSAGE_STATE', this.message.state)
            },
            readTypeDICT() {
                return DICT.getValue('PUSH_MESSAGE_READ_TYPE', this.message.readType)
            },
            resultValue() {
                let checkResult = [];
                if (this.message.pushWayApp) {
                    checkResult.push("APP")
                }
                if (this.message.pushWaySms) {
                    checkResult.push("短信")
                }
                if (this.message.pushWayTel) {
                    checkResult.push("电话")
                }
                if (this.message.pushWayWeb) {
                    checkResult.push("网页")
                }
                if (this.message.pushWayWechat) {
                    checkResult.push("微信")
                }
                return checkResult.join("，") || "无"
            }
        },
        created() {
        },
        mounted() {
            this.getDetail()
        },
        methods: {
            getDetail() {
                this.$http.tokiot.sys.pushMessage.get({id: this.id})
                    .then(res => {
                        if (res) {
                            this.formatNotice(res)
                            this.message = res
                            this.data = this.message.data
                        }
                    })
            },
            formatNotice(res) {
                res.data = JSON.parse(res.data)
            }
        },
        watch: {}
    }
</script>

<style lang="less" scoped>


    .van-cell__value {
        overflow: visible;
    }
</style>